import { useQuery } from "@tanstack/react-query";

import { api } from "./api";
import { Me } from "../types";

// useMe carrega quem está logado. Resultado fica em cache pra evitar
// chamadas redundantes em cada render do Layout. Em caso de 401 o
// próprio api.ts limpa a sessão e a app re-monta no LoginGate.
export function useMe() {
  return useQuery({
    queryKey: ["auth", "me"],
    queryFn: () => api<Me>("/auth/me"),
    staleTime: 60_000,
    retry: 0,
  });
}
